import React, { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { ROOT_PATH } from "@src/config";
import { ApiTypes } from "common";

interface OwnProps {
  user?: ApiTypes.ResGetMe["user"] | null;
  tab: keyof Pick<
    ApiTypes.ResGetMe["user"]["groupFeatures"],
    "product_catalog" | "share" | "widget" | "upload_ba" | "crm"
  >;
}

function AuthorizedPage({ user, tab, children }: PropsWithChildren<OwnProps>) {
  // Not (yet) authenticated
  if (!user) {
    return null;
  }

  if (user.groupFeatures[tab]) {
    return <>{children}</>;
  }
  return <Navigate to={ROOT_PATH} replace />;
}

export default AuthorizedPage;
